<template>
  <!-- :start-index="2" -->
  <!-- <button class="btn btn-primary btn-small" @click="testToast">Test Toast</button> -->
  <form-wizard
    ref="thisWizard"
    :steps="steps"
    color="#094899"
    back-button-text="Back"
    :next-button-text="nextButton"
    @on-validate="handleValidation"
    @on-complete="onComplete"
  >
    <tab-content title="Introductory" icon="fas fa-door-open" :before-change="goingToAdditional">
      <OnboardBasic ref="basic" @save="saveBasic" />
    </tab-content>
    <tab-content title="Additional Info" icon="fas fa-tasks" :before-change="goingToPurchase">
      <OnboardAdditional ref="additional" :companyId="companyId" @save="saveAdditional" />
    </tab-content>
    <tab-content title="Purchase" icon="fas fa-tag" :before-change="goingToThankYou">
      <OnboardPurchase ref="purchase" @restartPurchase="restartPurchase" @save="savePurchase" @makeToast="makeToast" />
    </tab-content>
    <tab-content title="Thank You!" icon="fas fa-thumbs-up">
      <OnboardThankYou ref="thankyou" />
    </tab-content>
  </form-wizard>
  <Toast ref="toast" :toasts="toasts" />
</template>
<script>
import { mapState, mapActions } from 'pinia'
import { onboardStore } from '@/stores/onboard'
import { FormWizard, TabContent } from 'vue3-form-wizard'
import OnboardBasic from './forms/OnboardBasic.vue'
import OnboardAdditional from './forms/OnboardAdditional.vue'
import OnboardPurchase from './forms/OnboardPurchase.vue'
import OnboardThankYou from './forms/OnboardThankYou.vue'
import Toast from '@/components/utilities/elements/Toast.vue'
import 'vue3-form-wizard/dist/style.css'
export default {
  name: 'OnboardWizard',
  components: {
    FormWizard,
    TabContent,
    OnboardBasic,
    OnboardAdditional,
    OnboardPurchase,
    OnboardThankYou,
    Toast
  },
  props: {
    companyId: {
      type: String,
      default: null
    },
    saveIt: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      showNext: true,
      toasts: [],
      nextButton: 'Next'
    }
  },
  async mounted() {
    await this.getLookups({
      keys: ['StateProvince', 'Country'],
      firm: 1,
      refresh: true
    })
    console.log('Onboard Wizard Save It', {
      saveIt: this.saveIt,
      companyId: this.companyId
    })
  },
  computed: {
    ...mapState(onboardStore, ['onboard', 'testMode', 'purchaseResult'])
  },
  methods: {
    ...mapActions(onboardStore, ['getLookups', 'setOnboard', 'toggleDisable', 'saveOnboard']),
    goTo(state) {
      this.$refs.thisWizard.changeTab(state.from, state.to)
    },
    testToast() {
      this.makeToast({
        variant: 'success',
        title: 'testing',
        content: 'Testing Toast.'
      })
      setTimeout(() => {
        this.makeToast({
          variant: 'danger',
          title: 'testing',
          content: 'An Error occurred.'
        })
      }, 500)
    },
    makeToast(data) {
      console.log('Making Toast', data.content)
      this.$refs.thankyou.setAllGood(false)
      if (data.variant === 'success' && data.source === 'purchase') {
        this.$refs.thankyou.setAllGood(true)
      }
      let toastClass = null
      if (data.variant === 'success') {
        toastClass = 'bg-success text-white'
      } else if (data.variant === 'warning') {
        toastClass = 'bg-warning'
      } else {
        toastClass = 'bg-danger text-white'
      }
      this.emitter.emit('show-toast', {
        title: data.title,
        message: data.content,
        class: toastClass,
        delay: 5000,
        autohide: true
      })
    },
    async goingToAdditional() {
      console.log('Going to Additional')
      this.toggleDisable(false)
      return this.$refs.basic.save()
    },
    async goingToPurchase() {
      console.log('Going to Purchase')
      this.toggleDisable(false)
      return this.$refs.additional.save()
    },
    async goingToThankYou() {
      console.log('Going to Thank You')
      this.toggleDisable(false)
      this.$refs.thankyou.setAllGood(false)
      return this.$refs.purchase.save(true)
    },
    handleValidation(isValid, tabIndex) {
      console.log('Validation', {
        isValid: isValid,
        tabIndex: tabIndex
      })
      if (isValid) {
        this.toggleDisable(true)
      }
    },
    async saveBasic(data) {
      // return from basic form "save" event
      console.log('Return from Save Basic', {
        data: data,
        saveIt: this.$refs.basic.isSave
      })
      if (data.valid) {
        this.setOnboard(data)
        let results = await this.saveOnboard('basic') // in onboard store
        this.$refs.basic.updateData(results)
        // Go to Additional
        this.goTo({
          from: 0,
          to: 1
        })
      } else {
        this.makeToast({
          variant: 'warning',
          title: 'Notice',
          content: 'Please fill in required fields on the form.'
        })
      }
    },
    async saveAdditional(data) {
      // return from additional form "save" event
      console.log('Return from Save Additional', {
        data: data,
        saveIt: this.$refs.additional.isSave
      })
      if (data.valid) {
        this.setOnboard(data)
        console.log('Save Additional', data)
        let results = await this.saveOnboard('additional') // in onboard store
        this.$refs.additional.updateData(results)
        // Go to Purchase
        this.goTo({
          from: 1,
          to: 2
        })
        this.nextButton = 'Purchase'
      } else {
        this.makeToast({
          variant: 'warning',
          title: 'Notice',
          content: 'Please fill in required fields on the form.'
        })
      }
    },
    async savePurchase(data) {
      // return from purchase form "save" event
      if (data.valid) {
        this.setOnboard(data)
        console.log('Save Purchase', data)
        let results
        // Save Customer, Purchase, Credit Card on Stripe
        // will also email a welcome letter with credentials
        results = await this.saveOnboard('purchase') // in onboard store
        this.showNext = false
        this.$refs.purchase.updateData(results)
        this.$refs.thankyou.setResults({
          email: this.onboard.basic.email,
          password: this.purchaseResult.password
        })
        // Go to Thank You
        this.goTo({
          from: 2,
          to: 3
        })
        this.nextButton = 'Finished'
      } else {
        this.makeToast({
          variant: 'warning',
          title: 'Notice',
          content: 'Please fill in required fields on the form.'
        })
      }
    },
    restartPurchase() {
      this.$refs.thankyou.setAllGood(false)
      this.$refs.thisWizard.changeTab(3, 2)
      this.nextButton = 'Purchase'
      this.$refs.purchase.restartPaymentMethod()
    },
    onComplete() {
      console.log('Wizard Complete')
      this.$router.push('/login')
    }
  }
}
</script>
<style lang="scss" scoped>
.wizard-icon-circle {
  color: rgb(255, 255, 255);
}
</style>
